import { LoadingButton } from "@mui/lab";
import { styled } from "@mui/material";
import { useEffect, useState } from "react";

let timer;

function CountdownButton({
  time,
  onClick,
  text,
  onComplete,
  onConfirm,
  ...props
}) {
  const [timeLeft, setTimeLeft] = useState(null);
  let lastCheck = 0;

  const handleStartCountDown = async () => {
    if (!timeLeft) {
      onClick(startCountDown);
    } else {
      if (onConfirm) onConfirm();
    }
  };

  function sleepCheck() {
    let now = new Date().getTime();
    let diff = now - lastCheck;
    if (diff > 3000) {
      startCountDown();
    }
    lastCheck = now;
  }

  useEffect(() => {
    lastCheck = new Date().getTime();
    setInterval(sleepCheck, 1000);
  }, []);

  const startCountDown = (tempTime) => {
    clearInterval(timer);

    setTimeLeft(tempTime || time);
    let tempTimeLeft = tempTime || time;

    timer = setInterval(() => {
      tempTimeLeft = tempTimeLeft - 1;
      setTimeLeft((v) => v - 1);

      if (tempTimeLeft === 0) {
        setTimeLeft(null);
        clearInterval(timer);
        if (onComplete) {
          onComplete();
        }
      }
    }, 1000);
  };

  return (
    <ButtonStyle
      variant="text"
      color="secondary"
      onClick={handleStartCountDown}
      {...props}
    >
      {text ? text + " " + (timeLeft || "") : timeLeft || "Get Code"}
    </ButtonStyle>
  );
}
const ButtonStyle = styled(LoadingButton)(() => ({
  fontSize: "13px",
}));
export default CountdownButton;
